import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Popover, Tooltip, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const ToBeStyledTooltip = ({ className, ...props }) => (
    <Tooltip {...props} classes={{ tooltip: className }} />
);

ToBeStyledTooltip.propTypes = {
    className: PropTypes.string,
};

const StyledTooltip = styled(ToBeStyledTooltip)(({ theme }) => ({
    backgroundColor: '#f5f5f9',
    color: '#827C91',
    maxWidth: 600,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
    zIndex: 1500,
}));
const TooltipContent = (content) => (
    <Box sx={{ backgroundColor: '#f5f5f9', color: '#827C91', maxWidth: 600 }}>
        <Typography component="ol" style={{ margin: 0, paddingLeft: '20px' }}>
            <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: 0 }}>
                <li>{content.character_restrict}</li>
                <li>{content.password_tooltip}</li>
                <li>{content.space_restriction}</li>
            </ul>
        </Typography>
    </Box>
);

const TooltipComponent = ({ anchorEl, handleClick, handleClose, id, open, content }) => {
    return (
        <div>
            <StyledTooltip title={<TooltipContent {...content} />} placement="bottom">
                <IconButton
                    onClick={handleClick}
                    sx={{
                        width: '0.8px',
                        height: '0.8px',
                        top: '-4px',
                        left: '10px',
                        gap: '0px',
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 25, color: '#827C91' }} />
                </IconButton>
            </StyledTooltip>
            {
                window.innerWidth < 1000 && (
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        sx={{ mt: 2 }}
                    >
                        <TooltipContent {...content} />
                    </Popover>
                )
            }
        </div>
    );
};

TooltipComponent.propTypes = {
    anchorEl: PropTypes.object,
    handleClick: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    id: PropTypes.string,
    open: PropTypes.bool.isRequired,
    content: PropTypes.object.isRequired,
};

export default TooltipComponent;
